if (!customElements.get('recipient-form')) {
    customElements.define(
      'recipient-form',
      class RecipientForm extends HTMLElement {
        constructor() {
          super();
          this.recipientFieldsLiveRegion = this.querySelector(`#Recipient-fields-live-region-${this.dataset.sectionId}`);
          this.checkboxInput = this.querySelector(`#Recipient-checkbox-${this.dataset.sectionId}`);
          this.checkboxInput.disabled = false;
          this.hiddenControlField = this.querySelector(`#Recipient-control-${this.dataset.sectionId}`);
          this.hiddenControlField.disabled = true;
          this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
          this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
          this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
          this.sendonInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`);
          this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${this.dataset.sectionId}`);
          if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();
  
          this.currentProductVariantId = this.dataset.productVariantId;
          this.addEventListener('change', this.onChange.bind(this));
          this.onChange();
        }
  
        cartUpdateUnsubscriber = undefined;
        variantChangeUnsubscriber = undefined;
  
        connectedCallback() {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
              this.resetRecipientForm();
            }
          });
  
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId === this.dataset.sectionId) {
              this.currentProductVariantId = event.data.variant.id.toString();
            }
          });
        }
  
        disconnectedCallback() {
          if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
          }
          if (this.variantChangeUnsubscriber) {
            this.variantChangeUnsubscriber();
          }
        }
  
        onChange() {
          if (this.checkboxInput.checked) {
            this.enableInputFields();
            if(this.sendonInput){
              var today = new Date();
              var monthNames = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE",
                  "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"];
              var formattedMinDate = monthNames[today.getMonth()] + " " + today.getDate() + ", " + today.getFullYear();
              this.sendonInput.setAttribute('placeholder', formattedMinDate);
            }
          } else {
            this.clearInputFields();
            this.disableInputFields();
          }
        }
  
        inputFields() {
          return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
        }
  
        disableableFields() {
          return [...this.inputFields(), this.offsetProperty];
        }
  
        clearInputFields() {
          this.inputFields().forEach((field) => (field.value = ''));
        }
  
        enableInputFields() {
          this.disableableFields().forEach((field) => (field.disabled = false));
        }
  
        disableInputFields() {
          this.disableableFields().forEach((field) => (field.disabled = true));
        }
  
        resetRecipientForm() {
          if (this.checkboxInput.checked) {
            this.checkboxInput.checked = false;
            this.clearInputFields();
          }
        }
      }
    );
  }

document.addEventListener('DOMContentLoaded', function() {
  const textarea = document.querySelector('.text-area.field__input');
  const maxCharMsg = document.querySelector('.field__label__message');

  textarea.addEventListener('input', function() {
      checkTextareaLength();
  });

  function checkTextareaLength() {
      if (textarea.value.length >= 200) {
          maxCharMsg.style.display = "block";
      } else {
          maxCharMsg.style.display = "none";
      }
  }

  textarea.addEventListener('input', autoResize, false);
  function autoResize() {
      this.style.height = 'auto';
      if (this.scrollHeight < 200) {
          this.style.height = this.scrollHeight + 'px';
      }
  }
  var fp = flatpickr(".date-selector", {
    altInput: true,
    altFormat: "F j, Y",
    dateFormat: "Y-m-d",
    minDate: "today",
    disableMobile: "true",
    maxDate: new Date().fp_incr(90),
    onReady: function(selectedDates, dateStr, instance) {
      if (instance.altInput.value) {
          instance.altInput.value = formatWithUppercase(instance.altInput.value);
      }
    },
    onChange: function(selectedDates, dateStr, instance) {
        instance.altInput.value = formatWithUppercase(instance.formatDate(selectedDates[0], "F j, Y"));
    }
  });
  function formatWithUppercase(dateStr) {
    return dateStr.split(' ').map(function (part, index) {
        return index === 0 ? part.toUpperCase() : part;
    }).join(' ');
  }
  
  window.openFlatpickr = function() {
      fp.open();
  };
  var calendarIcon = document.querySelector('.calendar-icon');
  calendarIcon.addEventListener('click', function() {
      fp.open(); 
  });

});
